import { Errors } from "shared/cubiq-model-multi-asset";
export class LogonResp {
  isSuccess: boolean;
  errors?: Errors;

  constructor(isSuccess: boolean, errors?: Errors) {
    this.isSuccess = isSuccess;
    this.errors = errors;
  }
}
